import type { EmitEvent } from "@/domains/core"
import type { Address } from "viem"
import type { Config } from "wagmi"
import type { IEventBus } from "@/domains/events"
import { EventEmitter } from "@/domains/library"
import { approveSuperVoterForAll } from "@/domains/on-chain"
import { SuperVoterAccessGrantedEvent } from "@/domains/vote-page/events"

interface MaxLockInteractionParams {
  account: Address
  chainId: number
  config: Config
  vestedAddress: Address
  superVoterAddress: Address
  emitter: EventEmitter<EmitEvent>
  eventBus: IEventBus
}

export const approveSuperVoterForAllInteraction = async ({
  account,
  chainId,
  config,
  vestedAddress,
  superVoterAddress,
  emitter,
  eventBus,
}: MaxLockInteractionParams) => {
  const result = await approveSuperVoterForAll({
    account,
    chainId,
    config,
    vestedAddress,
    superVoterAddress,
  })

  if (result.success) {
    // Emit domain event for orchestrator to refresh access state
    eventBus.publish(new SuperVoterAccessGrantedEvent(account, result.tx))
    // Emit user notification
    emitter.emit("max-lock", {
      title: "SuperVoter access",
      description: `SuperVoter access granted`,
      variant: "success",
    })
  }

  if (result.success === false) {
    emitter.emit("error-max-locking", {
      title: "SuperVoter access failed",
      description: `Unable to grant access to the SuperVoter, reason ${result.error}`,
      variant: "error",
    })
  }

  return result
}
